import { Pipe } from '@angular/core';
import dayjs from 'dayjs';

@Pipe({
  name: 'getKorDate',
  standalone: true,
})
export class GetKorDatePipe {
  transform(value: Date | string): string {
    const today = dayjs();
    const date = dayjs(value);

    if (today.diff(date, 'days') === 0) {
      if (today.diff(date, 'hours') === 0) {
        const current = today.diff(date, 'minutes');
        if (current < 1) {
          return '방금 전';
        } else {
          return `${today.diff(date, 'minutes')}분 전`;
        }
      } else {
        return `${today.diff(date, 'hours')}시간 전`;
      }
    } else if (today.diff(date, 'days') <= 29) {
      return `${today.diff(date, 'days')}일 전`;
    } else if (today.diff(date, 'month') < 12) {
      return `${today.diff(date, 'month')}달 전`;
    } else if (today.diff(date, 'year') < 1) {
      return `${today.diff(date, 'year')}년 전`;
    }

    return '';
  }
}
